import { render } from "./historyClassStudent.vue?vue&type=template&id=1560341f"
import script from "./historyClassStudent.vue?vue&type=script&lang=js"
export * from "./historyClassStudent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__